export enum OfficeChargeCategory {
  ALL = 'ALL',
  EXPORT = 'EXPORT',
  IMPORT = 'IMPORT',
}
